module.exports = function() {
  return new Worker(__webpack_public_path__ + "128de725b46d5d3165ab.worker.js");
};